import ActionTypes from '../action-types';
import { GTM_EVENTS, CART_QUANTITY_CHANGE, ADD_CTO_TO_CART } from '../track-params';
import { multiplyPriceByQuantity } from '../metrics-helpers';
import { Helpers } from '../../core/src/helpers';

const getCartAnalyticsFromCartItems = cartItems =>
    cartItems.map(ci => ({
        productId: ci.pNum,
        quantity: ci.qty,
        // Free items are set to 0.01 itemPrice based on requirements due to DY settings
        itemPrice: ci?.amt?.fg && ci?.amt?.nAmt == 0 ? 0.01 : Helpers.convertPriceToNumber(ci.amt.uPrice),
    }));

const getAddToCartEvent = params => {
    let event;
    try {
        const { ecommerce, cartItems = [] } = params;
        const { currencyCode, add } = ecommerce || {};
        const { products = [] } = add || {};
        const [product = {}] = products;
        event = {
            name: 'Add to Cart',
            properties: {
                dyType: 'add-to-cart-v1',
                value: product.price * 1,
                currency: currencyCode,
                productId: product.id,
                quantity: 1,
                cart: getCartAnalyticsFromCartItems(cartItems),
            },
        };
    } catch (e) {}
    return event;
};

const getCartSyncEvent = params => {
    let event;
    try {
        const { ecommerce, cartItems = [] } = params;
        const { currencyCode, add } = ecommerce || {};
        event = {
            name: 'Sync cart',
            properties: {
                dyType: 'sync-cart-v1',
                currency: currencyCode,
                cart: getCartAnalyticsFromCartItems(cartItems),
            },
        };
    } catch (e) {}
    return event;
};

const getLoginEvent = params => {
    let event;
    try {
        const { ecommerce, cartItems = [] } = params;
        const { currencyCode, add } = ecommerce || {};
        event = {
            name: 'Login',
            properties: {
                dyType: 'login-v1',
                hashedEmail: '',
            },
        };
    } catch (e) {}
    return event;
};

const getCartQuantityIncreaseEvent = params => {
    try {
        const { orderItemId, quantityChange } = params || {};
        if (!quantityChange || quantityChange < 1) {
            return null;
        }

        const cartItems = store.getState().cartInfo.items;
        const cartItem = cartItems.find(item => item && item.id === orderItemId);
        const { pNum } = cartItem;

        const { salePrice, regularPrice } = store.getState().productData.productInfo.productPrices[pNum] || {};
        const price = salePrice || regularPrice;
        const cartPrice = cartItem && cartItem.amt && cartItem.amt.uPrice;
        const calculatedPrice = multiplyPriceByQuantity(cartPrice || price, quantityChange);

        return {
            name: 'Add to Cart',
            properties: {
                dyType: 'add-to-cart-v1',
                value: calculatedPrice,
                currency: 'USD',
                productId: pNum,
                quantity: quantityChange,
                cart: getCartAnalyticsFromCartItems(cartItems),
            },
        };
    } catch (e) {}
};

/**
 * Performs event tracking from DY Personalization
 * @module DynamicYield
 * @class
 * @internal
 */
class DynamicYield {
    constructor(options = {}) {
        this.name = 'DY tag';
        this.optOut = false;
    }

    /**
     *
     * @method pageView
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    pageView(...args) {
        return this.track(...args);
    }

    /**
     *
     * @method track
     * @param {String} eventName
     * @param {Object} params
     * @param {Object} state
     * @returns {Promise}
     * @internal
     */

    track(eventName, params, state) {
        let dyEvent;
        const { event } = params || {};

        // switch statement to transform data into the accepted format.
        switch (event) {
            case GTM_EVENTS[ActionTypes.ADD_TO_CART]: {
                dyEvent = getAddToCartEvent(params);
                break;
            }
            case GTM_EVENTS[ActionTypes.REMOVE_FROM_CART]: {
                dyEvent = getCartSyncEvent(params);
                break;
            }
            case GTM_EVENTS[ActionTypes.UPDATE_CART]: {
                dyEvent = getCartSyncEvent(params);
                break;
            }
            /* Excluding this case since event requires email which we currently don't have access to from the React pages
           case GTM_EVENTS[ActionTypes.RECEIVE_UTILITY]: {
                dyEvent = getLoginEvent(params);
                break;
            }*/
            default: {
                break;
            }
        }

        if (dyEvent) {
            try {
                DY.API('event', dyEvent);
            } catch (e) {}
        }
    }

    cartMetric(eventName, params, state) {
        let dyEvent;

        switch (eventName) {
            case ADD_CTO_TO_CART:
            case CART_QUANTITY_CHANGE:
                dyEvent = getCartQuantityIncreaseEvent(params, state);
                break;
            default:
                break;
        }

        if (dyEvent) {
            try {
                DY.API('event', dyEvent);
            } catch (e) {}
        }
    }
}

export default DynamicYield;
